import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import useOnScreen from '@rio-cloud/rio-uikit/hooks/useOnScreen';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { TRACKING_ACTIONS } from '#configuration/setup/googleAnalytics.ts';
import { useTrackScreenSeen } from '#hooks/useTrackScreenSeen.ts';

type ErrorFallbackProps = {
    trackingCategory: string;
    errorMessage?: string;
};

const ErrorFallback = ({ trackingCategory, errorMessage }: ErrorFallbackProps) => {
    const ref = useRef(null);
    const onScreen = useOnScreen(ref);

    useTrackScreenSeen(onScreen, {
        category: trackingCategory,
        action: TRACKING_ACTIONS.ON_SCREEN,
        label: 'Show error fallback',
    });

    return (
        <ErrorState
            outerClassName='margin-top-20'
            headline={<FormattedMessage id='intl-msg:common-message.error.generic.headline' />}
            message={
                <div ref={ref}>
                    <FormattedMessage id='intl-msg:common-message.error.generic.message' />
                    {errorMessage && <div className='margin-top-15 text-color-dark'>{errorMessage}</div>}
                </div>
            }
        />
    );
};

export default ErrorFallback;
